module.exports = __webpack_public_path__ + "static/media/socrypto-large-white.81811e88.svg";